import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';

import validationSchema from 'src/utils/validationSchema';

import { useTranslate } from 'src/locales';
import { useChannelContext } from 'src/pages/channel/hooks';
import { ChannelStepLayout } from 'src/pages/channel/shared';

import { Form, Field } from 'src/components/hook-form';

export default function VoiceStep1() {
  const { handleChannelName, state: channelState, onChangeStep } = useChannelContext();

  const { t } = useTranslate('translation');

  type VoiceCallField = { channelName: string };

  const fldList = [{ name: 'channelName', required: true }];

  const CampaignSchema = validationSchema(fldList, t);

  const defaultValues: VoiceCallField = {
    channelName: channelState.channelName || '',
  };

  const methods = useForm<VoiceCallField>({
    mode: 'all',
    resolver: zodResolver(CampaignSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    watch,
    formState: { isValid },
  } = methods;

  const channelName = watch('channelName');

  const onSubmit = handleSubmit(async (data) => {
    handleChannelName(data.channelName);
    onChangeStep('next');
  });

  const isNextDisabled = !isValid || !channelName;

  return (
    <Stack spacing={4} sx={{ height: '100%' }}>
      <Form methods={methods} onSubmit={onSubmit}>
        <ChannelStepLayout title="" subtitle="" isNextDisabled={isNextDisabled}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 8, lg: 6 }}>
              <Field.Text
                name="channelName"
                label={t('CHANNEL_NAME')}
                placeholder={t('ENTER_CHANNEL_NAME_PLACEHOLDER')}
                InputLabelProps={{ shrink: true }}
                autoFocus
              />
            </Grid>
          </Grid>
        </ChannelStepLayout>
      </Form>
    </Stack>
  );
}
